import { compose } from 'react-apollo';
import {withRouter} from 'react-router';

import LeadsCallbacksPage from './LeadsCallbacksPage';


export default compose(
  withRouter,
)(LeadsCallbacksPage);